import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "button", "icon"]
  static classes = ["hidden"]

  declare readonly itemTargets: HTMLElement[]
  declare readonly buttonTargets: HTMLElement[]
  declare readonly iconTargets: HTMLElement[]
  declare readonly hiddenClasses: string[]

  toggle(event: Event) {
    const button = event.currentTarget as HTMLElement
    const buttonIndex = this.buttonTargets.indexOf(button)
    if (buttonIndex === -1) return

    const item = this.itemTargets[buttonIndex]
    if (!item) return

    const icon = this.iconTargets[buttonIndex]

    const isHidden = this.hiddenClasses.some((cls) =>
      item.classList.contains(cls),
    )

    // Close all items and reset all icons
    this.itemTargets.forEach((target, index) => {
      this.hiddenClasses.forEach((cls) => target.classList.add(cls))
      if (this.iconTargets[index]) {
        this.iconTargets[index].classList.remove("rotate-180")
      }
    })

    // If the clicked item was hidden, open it and rotate its icon
    if (isHidden) {
      this.hiddenClasses.forEach((cls) => item.classList.remove(cls))
      if (icon) {
        icon.classList.add("rotate-180")
      }
    }
  }
}
